<article class="glassmorphism table-card" [class.hovered]="isHovered | async">
  <hgroup>
    <h2 class="card-title">{{ table.getTitle() }}</h2>
    <button type="button" (click)="deleteTable()">
      <span class="outside-window">Effacer le lien</span>
      <svg-trash></svg-trash>
    </button>
  </hgroup>
  <ul>
    @for (attribute of table.getAttributeList(); track $index) {
      <li>{{ attribute.name }}</li>
    }
  </ul>
</article>
